import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../store';
import { Company, CompanyIndustryData, CompanyPostCode, CreateCompany, UpdateCompany } from '../../types/company';
import { apiSlice } from './apiSlice';
import { CompanyIndustry } from '../../types/industry';

export const companiesApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCompanies: builder.query<Company[], void>({
            query: () => '/companies',
            keepUnusedDataFor: 60,
            providesTags: ['Company']
        }),
        getCompanyById: builder.query<Company, string>({
            query: (companyId: string) => `/companies/company/${companyId}`,
            keepUnusedDataFor: 5,
            providesTags: ['Company']
        }),
        deleteCompanyById: builder.mutation({
            query: (companyId: string) => ({
                url: `/companies/company/${companyId}`,
                method: 'DELETE',
                responseHandler: (response) => response.text(),
            }),
            invalidatesTags: ['Company']
        }),
        createCompany: builder.mutation({
            query: (company: CreateCompany) => ({
                url: `/companies`,
                method: 'POST',
                body: { ...company },
            })
        }),
        updateCompany: builder.mutation({
            //@ts-ignore
            query: ({ companyId, company }: {
                companyId: string, company: UpdateCompany
            }) => ({
                url: `/companies/company/${companyId}`,
                method: 'PUT',
                body: { ...company },
            })
        }),
    })
})

export const { useGetCompaniesQuery, useGetCompanyByIdQuery, useDeleteCompanyByIdMutation, useCreateCompanyMutation, useUpdateCompanyMutation } = companiesApiSlice;